import { defineStore } from 'pinia'
import HouseIcon from '@/assets/icons/House.svg'
import SettingsIcon from '@/assets/icons/Settings.svg'
import CommandsIcon from '@/assets/icons/Command.svg'
import DesctopTowerIcon from '@/assets/icons/Desktop_Tower.svg'
import FileIcon from '@/assets/icons/File_Document.svg'
import MailIcon from '@/assets/icons/Mail.svg'

import { useUserStore } from '@/store/UserStore'

export const useNavigationStore = defineStore('navigation', {
    state: () => ({
        activeTabId: localStorage.getItem('active_tab') || 'home',
        tabs: [
            {
                id: 'home',
                text: 'Домашняя страница',
                path: '/home',
                icon: HouseIcon,
                active: true,
            },
            {
                id: 'models',
                text: 'Модели',
                path: '/models',
                icon: CommandsIcon,
                hasRoles: ['ROLE_ADMIN', 'ROLE_MODELS_MANAGER'],
            },
            {
                id: 'finance',
                text: 'Финансы',
                path: '/finances',
                icon: FileIcon,
                active: true,
                hasRoles: ['ROLE_ADMIN'],
            },
            {
                id: 'senders',
                text: 'Отправители',
                path: '/senders',
                icon: MailIcon,
                hasRoles: ['ROLE_ADMIN'],
            },
            {
                id: 'external-services',
                text: 'Внешние сервисы',
                path: '/external-services',
                icon: DesctopTowerIcon,
                hasRoles: ['ROLE_ADMIN'],
            },
            {
                id: 'settings',
                text: 'Настройки',
                path: '/settings',
                icon: SettingsIcon,
                hasRoles: ['ROLE_ADMIN', 'ROLE_ZERO'],
            }
        ],
        isNavBarVisible: localStorage.getItem('isNavBarVisible') !== null
            ? localStorage.getItem('isNavBarVisible') === 'true'
            : window.innerWidth > 768,
        isHeaderVisible: localStorage.getItem('isHeaderVisible') !== 'false',
        isAiChatVisible: localStorage.getItem('isAiChatVisible') === 'true',
    }),

    getters: {
        visibleTabs: (state) => {
            const userStore = useUserStore();
            const userRoles = userStore.myUserInfo?.roles?.map(role => role.name) || [];

            var filteredTabs = state.tabs.filter(tab => {
                // Если roles не указаны, показываем всем
                if (!tab.hasRoles || tab.hasRoles.length === 0) {
                    return true;
                }
                // Если есть hasRoles, проверяем наличие хотя бы одной роли
                return tab.hasRoles.some(role => userRoles.includes(role));
            });

            return filteredTabs
        }
    },

    actions: {
        setActiveTab(tabId) {
            this.tabs.forEach(item => {
                item.active = false;
            })
            const tab = this.tabs.find(item => item.id === tabId);
            if (tab) {
                tab.active = true;
            }
            this.activeTabId = tabId;
            localStorage.setItem("active_tab", tabId);
        },

        setNavBarVisible(isVisible) {
            this.isNavBarVisible = isVisible;
            localStorage.setItem('isNavBarVisible', isVisible);
        },

        setHeaderVisible(isVisible) {
            this.isHeaderVisible = isVisible;
            localStorage.setItem('isHeaderVisible', isVisible);
        },

        toggleNavBar() {
            this.isNavBarVisible = !this.isNavBarVisible;
            localStorage.setItem('isNavBarVisible', this.isNavBarVisible);
        },

        toggleAiChat() {
            this.isAiChatVisible = !this.isAiChatVisible;
            localStorage.setItem('isAiChatVisible', this.isAiChatVisible);
        }
    }
})
